import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import LoadingPage from './LoadingPage';

const AdminRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const token = localStorage.getItem('jwtToken');

        // Check if the user is an admin
        const checkAdmin = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user/me`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });
                setIsAdmin(response.data.is_admin);
            } catch (err) {
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkAdmin();
    }, [API_URL]);

    if (loading) return <LoadingPage />;

    // If the user is not an admin, redirect to the home page
    return isAdmin ? children : <Navigate to="/" />;
};

export default AdminRoute;
